import { req } from './axiosFun';

// 查询位置列表
export const listAgent=(query)=> {
  return req(
    "post",
    "/api/admin/agent/list",
    query
  )
}

// 查询位置详细
export const getAgent=(id)=> {
  return req(
    'get',
    '/api/admin/agent/',
    id
  )
}

// 新增位置
export const saveAgent=(data)=> {
  return req(
    'post',
    '/api/admin/agent/save',
    data
  )
}

// 新增位置
export const addAgent=(data)=> {
  return req(
    'post',
    '/api/admin/agent',
    data
  )
}

// 修改位置
export const updateAgent=(data)=> {
  return req(
    'put',
    '/api/admin/agent',
    data
  )
}

// 删除位置
export const delAgent=(id)=> {
  return req(
    'post',
    '/api/admin/agent/deleteAgent',
    id
  )
}



// WEBPACK FOOTER //
// ./src/api/agent.js